import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { AuthService, ResolverLoadingService } from 'pbc.angular';

import { IZeitUnterartsResponse } from 'fa-kt.types';
import { PostZeitUnterartCommandService } from '../commands';
import { ZeitUnterartsService } from '../query';

@Injectable({
  providedIn: 'root',
})
export class ZeitUnterartsPageResolver implements Resolve<IZeitUnterartsResponse | void> {
  constructor(
    private loading: ResolverLoadingService,
    private authService: AuthService,
    private zeitUnterarts: ZeitUnterartsService,
    private postZeitUnterart: PostZeitUnterartCommandService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IZeitUnterartsResponse | void> {
    this.loading.resolving();
    const log = (error: any) => console.error(error);
    const [zeitUnterarts] = await Promise.all([this.zeitUnterarts.request({}).catch(log), this.postZeitUnterart.prepare(true).catch(log)]);
    this.loading.resolved();
    return zeitUnterarts;
  }
}
